import { gsap } from "gsap";

export function heroAnimation() {
  const group1 = document.querySelectorAll(".group-1");
  const group2 = document.querySelectorAll(".group-2");

  // Парящих карточек нет на посадочной под рекламу (/fb): там герой — одна цельная
  // картинка. Без этой проверки gsap пишет в консоль «target not found» на каждый вызов.
  if (!group1.length && !group2.length) {
    return;
  }

  const TICK = 1;
  const DELAY = 0.6;

  // autoAlpha, а не opacity: это та же прозрачность плюс `visibility: hidden`
  // ровно в нуле. Полностью погасшая карточка перестаёт быть содержимым для
  // отрисовки, а не остаётся невидимой при прозрачности 0 — Safari на macOS
  // оставлял от неё «призрак» последнего кадра (см. `&--img` в _hero.scss).
  // Обратно autoAlpha ставит `visibility: inherit`, родитель видим.
  gsap.set([group1, group2], { autoAlpha: 0, scale: 0.8 });

  const tl = gsap.timeline({ repeat: -1 });

  tl.to(group1, {
    autoAlpha: 1,
    scale: 1,
    duration: TICK,
    ease: "power2.out",
  });

  tl.to(group1, {
    autoAlpha: 0,
    scale: 0.8,
    duration: TICK,
    ease: "power2.in",
    delay: DELAY,
  });

  tl.to(group2, {
    autoAlpha: 1,
    scale: 1,
    duration: TICK,
    ease: "power2.out",
  });

  tl.to(group2, {
    autoAlpha: 0,
    scale: 0.8,
    duration: TICK,
    ease: "power2.in",
    delay: DELAY,
  });

  pauseWhenOffscreen(tl, (group1[0] || group2[0]).closest('section') || document.body);
}

// Бесконечный таймлайн тикает и за экраном: gsap каждый кадр пишет стили карточкам, браузер
// их компонует — на Android Chrome это лишняя работа прямо во время прокрутки страницы.
// Вне экрана таймлайн стоит, в кадре продолжается с того же места.
function pauseWhenOffscreen(tl, container) {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      tl.resume();
    } else {
      tl.pause();
    }
  });

  observer.observe(container);
}
